import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { CmsPageGuard, MediaModule, PageLayoutComponent } from '@spartacus/storefront';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { PotentialPromotionsModule } from '../../potential-promotions/potential-promotions.module';
import { PromotionalTextModule } from '../../promotional-text/promotional-text.module';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
import { CartExportModule } from '../cart-details/cart-export/cart-export.module';
import { MemoModule } from '../memo/memo.module';
import { SavedCartDetailsComponent } from './saved-cart-details.component';
import { EditCartModalComponent } from './saved-cart-overview/edit-cart-modal/edit-cart-modal.component';
import { SavedCartOverviewComponent } from './saved-cart-overview/saved-cart-overview.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    CartExportModule,
    MediaModule,
    UrlModule,
    I18nModule,
    DynamicFormsModule,
    PromotionalTextModule,
    PotentialPromotionsModule,
    TooltipIconModule,
    TooltipTextModule,
    MemoModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'savedcartDetails' },
      },
    ]),
    SavedCartDetailsComponent,
    SavedCartOverviewComponent,
    EditCartModalComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AccountSavedCartDetailsEntriesComponent: {
          component: SavedCartDetailsComponent,
        },
        AccountSavedCartDetailsOverviewComponent: {
          component: SavedCartOverviewComponent,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.SavedCarts,
    }),
  ],
  exports: [SavedCartDetailsComponent, SavedCartOverviewComponent, EditCartModalComponent],
})
export class SavedCartDetailsModule {}
